import emailjs from '@emailjs/browser';
// Initialize EmailJS with your public key
emailjs.init('jEY1sUlBXoyk9Zmwd');

export function sendEmail(form) {
    const params = {
        name: form.name,
        email: form.email,
        message: form.message,
        subject: form.subject || '' // Optional, if you want to add subject
    };

    return emailjs.send('service_c1jfopj', 'template_97px1rq', params)
        .then(() => alert('Email sent successfully!'));
}
